import React, { useLayoutEffect, useState } from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Carousel from 'tbk-components/src/components/Carousel';
import CarouselItem from 'tbk-components/src/components/CarouselItem';

export interface ProcessItems {
	heading?: string;
	/**
	 * @control textarea
	 */
	text?: string;
}

export interface IProcessProps extends IBaseElementProps {
	/**
	 * @control uniqueid
	 * @prefix performance-component
	 */
	id?: string;
	theme?: 'Light' | 'Dark';
	/**
	 * Process Items - Up to 7 items will be displayed
	 */
	processItems?: ProcessItems[];
}

/**
 * Calian Process
 * @block
 * @icon performance
 */
const Process: React.FC<IProcessProps> = ({
	className,
	classNames = [],
	id,
	theme = 'Light',
	processItems,
}) => {
	const [stepText, setStepText] = useState<string>('Step');

	useLayoutEffect(() => {
		const htmlLang = document.documentElement.lang;
		const isFrench = htmlLang === 'fr-CA' || htmlLang === 'fr-FR';

		if (isFrench) {
			setStepText('Étape');
		}
	}, []);

	return (
		<div
			className={
				className ||
				cn(
					'calian-process',
					{
						[`theme-${kebabCase(theme)}`]: theme,
					},
					...classNames,
				)
			}
		>
			<div className="calian-process__container container-fluid mw-1440px py-3 py-lg-5">
				{processItems && processItems.length > 0 && (
					<div className="calian-process__item-listing pb-lg-4">
						<Carousel
							id={id}
							onMount={(glide, ref) => {
								ref.querySelectorAll('.glide__bullet').forEach(
									(bullet, index) => {
										// @ts-ignore
										bullet.innerHTML = `<span class="step-text d-inline-block"><span class="d-none d-md-inline-block">${stepText}</span> ${
											index + 1
										}</span>`;
									},
								);
							}}
						>
							{processItems.map(({ heading, text }, index) => {
								if (index < 10) {
									return (
										<CarouselItem key={index}>
											<div className="calian-process__item p-4 pt-lg-6 pb-lg-0 ps-lg-0 pe-lg-10">
												<h2>{heading}</h2>
												<p className="mb-0 mb-lg-5">
													{text}
												</p>
											</div>
										</CarouselItem>
									);
								}
							})}
						</Carousel>
					</div>
				)}
			</div>
		</div>
	);
};

export default Process;
